import { motion } from "framer-motion";

export const Marquee = ({ items, className = "" }) => {
  const row = [...items, ...items, ...items];
  return (
    <div
      className={`overflow-hidden border-y border-black/10 py-6 ${className}`}
      data-testid="editorial-marquee"
    >
      <motion.div
        className="flex w-max items-center whitespace-nowrap"
        animate={{ x: ["0%", "-33.333%"] }}
        transition={{ duration: 40, ease: "linear", repeat: Infinity }}
      >
        {row.map((item, i) => (
          <span
            key={i}
            className="font-syne mx-8 flex items-center gap-8 text-2xl font-bold uppercase tracking-wide text-foreground sm:text-4xl"
          >
            {item}
            <span className="text-foreground/30">·</span>
          </span>
        ))}
      </motion.div>
    </div>
  );
};
